import { ViewerMode } from './urlState';

export type MobileContext = 'watch' | 'map' | 'cars';

export function deriveMobileContext(
  mode: ViewerMode,
  mobilePanelOpen: boolean,
  hasSelection: boolean,
): MobileContext {
  if (hasSelection && (mode === 'detail' || mode === 'theater')) return 'watch';
  if (mobilePanelOpen) return 'cars';
  return 'map';
}
